<div class="w3layouts-main">
  <div class="bg-layer">
    <h1>THINKAERIAL LIVE DRONE SYSTEM </h1>
    <div class="header-main">
      <div class="main-icon">
        <span class="fa fa-eercast"></span>
      </div>
      <div class="header-left-bottom">
        <form [formGroup]="validateForm" (ngSubmit)="submitForm()">
          <nz-form-item>
            <nz-form-control nzErrorTip="Please input your username!">
              <nz-input-group nzPrefixIcon="user">
                <input type="text" nz-input formControlName="username" placeholder="Username" />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control nzErrorTip="Please input your Password!">
              <nz-input-group nzPrefixIcon="lock">
                <input type="password" nz-input formControlName="password" placeholder="Password" />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
          <!-- <div class="login-check">
            <label class="checkbox"><input type="checkbox" name="checkbox" checked=""><i> </i> Keep me logged in</label>
          </div> -->
          <div class="bottom">
            <button type="submit" class="btn">Log In</button>
          </div>
          <div class="links">
            <p><a href="https://wa.me/918097739224" target="_blank">Forgot Password?</a></p>
            <p class="right"><a href="https://wa.me/918097739224" target="_blank">New User? Register</a></p>
            <div class="clear"></div>
          </div>
        </form>
      </div>
      <!--		<div class="social">
				<ul>
					<li>or login using : </li>
					<li><a href="#" class="facebook"><span class="fa fa-facebook"></span></a></li>
					<li><a href="#" class="twitter"><span class="fa fa-twitter"></span></a></li>
					<li><a href="#" class="google"><span class="fa fa-google-plus"></span></a></li>
				</ul>
			</div>
		</div>
	-->
      <!-- copyright -->
      <div class="copyright">
        <p>©<a href="https://www.thinkaerial.com">ThinkAerial</a> . All rights reserved | Design by THINKAERIAL
            
      </div>
      <!-- //copyright -->
    </div>
  </div>
